import { useEffect, useState } from 'react';
import { api, timeAgo, type SourceHealthRow } from '../lib/api';

export function SourceHealth() {
  const [rows, setRows] = useState<SourceHealthRow[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.sourceHealth()
      .then((res) => setRows(res.sources))
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="page-title">SOURCE HEALTH</div>
      <div className="page-sub">Every data source, its compliance status, and whether it is delivering.</div>
      {error && <div className="error-banner">{error}</div>}
      {loading && <div className="empty">Checking sources…</div>}
      <div className="cards">
        {rows.map((s) => (
          <div className="panel" key={s.id} style={{ marginBottom: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
              <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>{s.name}</div>
              <span className={`health-state ${s.state}`}>{s.state.replace('_', ' ')}</span>
            </div>
            <div className="account-stats" style={{ marginTop: 10, flexWrap: 'wrap' }}>
              <span>Registry: <b>{s.status}</b></span>
              <span>Cadence: <b>{s.refreshFrequency ?? '—'}</b></span>
              <span>Last run: <b>{timeAgo(s.lastAttemptedRun)}</b></span>
              <span>Last success: <b>{timeAgo(s.lastSuccessfulRun)}</b></span>
              <span>Received: <b>{s.recordsReceived}</b></span>
              <span>New: <b>{s.recordsNew}</b></span>
              <span>Promoted: <b>{s.recordsPromoted}</b></span>
            </div>
            {s.lastError && <div className="error-banner" style={{ marginTop: 10, marginBottom: 0 }}>{s.lastError}</div>}
            {s.notes && <div className="notice">{s.notes}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
